const BASE_URL = process.env.REACT_APP_BASE_URL;
export const API_BASE_URL = {
  LOGIN: `${BASE_URL}/auth`,
  SIGNUP: `${BASE_URL}/auth/signup`,
  ENTIDADE: `${BASE_URL}/entidade`,
  PESSOA: `${BASE_URL}/pessoa`,
  EMISSOR: `${BASE_URL}/emissor`,
  ATA: `${BASE_URL}/ata`,
  USUARIO: `${BASE_URL}/usuario`,
  VINCULO: `${BASE_URL}/vinculo`,
  UF: `${BASE_URL}/uf`,
  MUNICIPIO: `${BASE_URL}/municipio`,
  TEMPLATE: `${BASE_URL}/template`,
  CATMAT: `${BASE_URL}/catmat`,
  DEMANDA: `${BASE_URL}/demanda`,
  DEMANDA_ITEM: `${BASE_URL}/demanda_item`,
  DEMANDA_LOTE: `${BASE_URL}/demanda_lote`,
  CATMAT_UM: `${BASE_URL}/catmatum`,
  CATSER: `${BASE_URL}/catser`,
  CATSER_UM: `${BASE_URL}/catserum`,
  CNPJ_PROXY: `${BASE_URL}/cnpj`,
  EFISCO_PE: `${BASE_URL}/efiscope`,
  UNIDADE_MEDIDA: `${BASE_URL}/unidade_medida`,
  PESQUISA_PRECO_MATERIAL: `${BASE_URL}/pesquisa_preco_material`,
  PESQUISA_PRECO_SERVICO: `${BASE_URL}/pesquisa_preco_servico`,
};
